import { useEffect } from "react";
import api from "@/lib/api";

export const IDLE_MS = 45 * 60 * 1000;
const EVENTS = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "wheel"];

export const markActive = (key) => localStorage.setItem(`${key}_lastActive`, String(Date.now()));

// Signs the user out after 45 minutes without interaction (shared across tabs), and keeps the server session alive while active.
export function useIdleLogout(user, key, onIdle) {
  useEffect(() => {
    if (!user) return undefined;
    const k = `${key}_lastActive`;
    const last = () => Number(localStorage.getItem(k) || 0);
    if (last() && Date.now() - last() > IDLE_MS) { onIdle(); return undefined; }
    if (!last()) markActive(key);
    let lastPing = 0;
    const mark = () => { if (Date.now() - last() > 10000) markActive(key); };
    const tick = () => {
      const now = Date.now();
      if (now - last() > IDLE_MS) { onIdle(); return; }
      if (last() > lastPing && now - lastPing >= 120000) { lastPing = now; api.post("/auth/activity").catch(() => {}); }
    };
    EVENTS.forEach((e) => window.addEventListener(e, mark, { passive: true }));
    const id = setInterval(tick, 30000);
    tick();
    return () => { clearInterval(id); EVENTS.forEach((e) => window.removeEventListener(e, mark)); };
  }, [user, key, onIdle]);
}
